const TaxRegime = {
  fatca: 1,
  crs: 2
};

export default TaxRegime;
